export function parseWorkflow(workflowText) {
  try {
    let cleanedText = workflowText;
    if (workflowText.includes("```json")) {
      cleanedText = workflowText.replace(/```json\s*\n?/g, "").replace(/```\s*$/g, "");
    } else if (workflowText.includes("```")) {
      cleanedText = workflowText.replace(/```\s*\n?/g, "");
    }

    const parsed = JSON.parse(cleanedText.trim());

    if (parsed.steps && Array.isArray(parsed.steps)) {
      return {
        steps: parsed.steps.map((step) => ({
          title: step.title || "Untitled Step",
          tool: step.tool || "unknown_tool",
          description: step.description || "",
          // 👇 show params in the UI where "input" used to be
          input:
            step.input ||
            (step.params ? JSON.stringify(step.params, null, 2) : ""),
          // output may start empty "" and later be filled by server
          output: step.output || "",
        })),
        source: "openai",
      };
    }
  } catch (e) {
    // (keep your existing salvage + fallback)
  }

  return { /* your existing fallback */ };
}
